import Http from '@/services/httpAcademy'

export const getDashboardStats = () => Http.get('/admin/dashboard')
